const TOUR_COMPLETED_KEY = 'nextstep-tour-completed'

export const setTourCompleted = () => {
	if (typeof window === 'undefined') return
	localStorage.setItem(TOUR_COMPLETED_KEY, 'true')
}

export const isTourCompleted = (): boolean => {
	if (typeof window === 'undefined') return false
	return localStorage.getItem(TOUR_COMPLETED_KEY) === 'true'
}

